import React from 'react';

const headingBox = (props) => (
    <div className={`u-flex f-column u-width100Percent phone-align-items-center`}>
        {props.children}
    </div>
);

export default headingBox;


// WEBPACK FOOTER //
// ./src/components/UI/Headings/HeadingBox/HeadingBox.js